import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { removeEmpty, buildQueryParams } from '../../utils/object';

export const cropApi = createApi({
  reducerPath: 'cropApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCropFilters: builder.query({
      query: (args = {}) => {
        const params = removeEmpty(args);
        return {
          url: 'crop/filters',
          ...(Object.keys(params).length > 0 && { params: params }),
        };
      },
    }),
    getCrops: builder.query({
      query: ({ page, limit, search } = {}) => ({
        url: 'crop',
        params: buildQueryParams({ page, limit, search }),
      }),
    }),
    addNewCrop: builder.mutation({
      query: (newCrop) => ({
        url: 'crop',
        method: 'POST',
        body: newCrop,
      }),
    }),
    updateCrop: builder.mutation({
      query: ({ id, updatedCrop }) => ({
        url: `crop/${id}`,
        method: 'PUT',
        body: updatedCrop,
      }),
    }),
  }),
});

export const {
  useGetCropFiltersQuery,
  useGetCropsQuery,
  useAddNewCropMutation,
  useUpdateCropMutation,
} = cropApi;
